// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.admin-edit-user-wrapper {
  -webkit-user-select: auto;
     -moz-user-select: auto;
          user-select: auto;
}
.admin-edit-user-wrapper .editable-value .fa {
  color: #515554;
  margin-left: 0.5rem;
}
.admin-edit-user-wrapper .user-info {
  display: flex;
  flex-flow: row wrap;
}
.admin-edit-user-wrapper .user-info__email, .admin-edit-user-wrapper .user-info__trial, .admin-edit-user-wrapper .user-info__tax-percentage, .admin-edit-user-wrapper .user-info__stripe-id, .admin-edit-user-wrapper .user-info__paddle-id, .admin-edit-user-wrapper .user-info__password, .admin-edit-user-wrapper .user-info__trial, .admin-edit-user-wrapper .user-info__address, .admin-edit-user-wrapper .user-info__subscription-level {
  padding: 0 0.5rem;
  flex: 0 0 auto;
}
.admin-edit-user-wrapper .user-info__stripe-id, .admin-edit-user-wrapper .user-info__email {
  flex: 1 1 50%;
}
.admin-edit-user-wrapper .user-info__stripe-id {
  text-align: right;
}
.admin-edit-user-wrapper .user-info__name, .admin-edit-user-wrapper .user-info__password, .admin-edit-user-wrapper .user-info__trial, .admin-edit-user-wrapper .user-info__tax-percentage, .admin-edit-user-wrapper .user-info__subscription-level {
  flex: 1 1 100%;
}
.admin-edit-user-wrapper .subscriptions__title,
.admin-edit-user-wrapper .calendars__title {
  font-size: 2rem;
  font-weight: bold;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0.5rem;
}
.admin-edit-user-wrapper .subscriptions .calendar,
.admin-edit-user-wrapper .calendars .calendar {
  padding: 0.5rem;
}
.admin-edit-user-wrapper .subscriptions .calendar__color, .admin-edit-user-wrapper .subscriptions .calendar__hidden, .admin-edit-user-wrapper .subscriptions .calendar__name,
.admin-edit-user-wrapper .calendars .calendar__color,
.admin-edit-user-wrapper .calendars .calendar__hidden,
.admin-edit-user-wrapper .calendars .calendar__name {
  flex: 0 0 auto;
}
.admin-edit-user-wrapper .subscriptions .calendar__color,
.admin-edit-user-wrapper .calendars .calendar__color {
  flex: 0 0 10rem;
}
.admin-edit-user-wrapper .subscriptions .calendar__color .color-box,
.admin-edit-user-wrapper .calendars .calendar__color .color-box {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  border-width: 0.2rem;
  border-style: solid;
}
.admin-edit-user-wrapper .subscriptions .calendar__hidden,
.admin-edit-user-wrapper .calendars .calendar__hidden {
  padding: 0 0.5rem;
  font-size: 2rem;
}
.admin-edit-user-wrapper .subscriptions .calendar__hidden .active,
.admin-edit-user-wrapper .calendars .calendar__hidden .active {
  color: #dabc64;
}
.admin-edit-user-wrapper .subscriptions .calendar__calendar-id,
.admin-edit-user-wrapper .calendars .calendar__calendar-id {
  flex: 1 1 100%;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 2rem;
  white-space: nowrap;
}
.admin-edit-user-wrapper .subscriptions .calendar__last-error,
.admin-edit-user-wrapper .calendars .calendar__last-error {
  flex: 0 0 100%;
}
.admin-edit-user-wrapper .subscriptions .calendar__error-count,
.admin-edit-user-wrapper .calendars .calendar__error-count {
  padding-right: 0.5rem;
}
.admin-edit-user-wrapper .subscriptions .calendar .calendar-top,
.admin-edit-user-wrapper .calendars .calendar .calendar-top {
  display: flex;
}
.admin-edit-user-wrapper .subscriptions .calendar .calendar-bottom,
.admin-edit-user-wrapper .calendars .calendar .calendar-bottom {
  display: flex;
  flex-flow: row wrap;
}
.admin-edit-user-wrapper .subscriptions__list .subscription,
.admin-edit-user-wrapper .calendars__list .subscription {
  padding: 0.5rem;
  text-align: left;
}
.admin-edit-user-wrapper .subscriptions__list .subscription span,
.admin-edit-user-wrapper .calendars__list .subscription span {
  padding-right: 0.5rem;
}
.admin-edit-user-wrapper .subscriptions__list .subscription .subscription-bottom,
.admin-edit-user-wrapper .subscriptions__list .subscription .subscription-top,
.admin-edit-user-wrapper .calendars__list .subscription .subscription-bottom,
.admin-edit-user-wrapper .calendars__list .subscription .subscription-top {
  display: flex;
  flex-flow: row;
}
.admin-edit-user-wrapper .subscriptions__list .subscription__plan, .admin-edit-user-wrapper .subscriptions__list .subscription__trial, .admin-edit-user-wrapper .subscriptions__list .subscription__created,
.admin-edit-user-wrapper .calendars__list .subscription__plan,
.admin-edit-user-wrapper .calendars__list .subscription__trial,
.admin-edit-user-wrapper .calendars__list .subscription__created {
  flex: 0 0 auto;
  text-align: left;
}
.admin-edit-user-wrapper .subscriptions__list .subscription__ends, .admin-edit-user-wrapper .subscriptions__list .subscription__id,
.admin-edit-user-wrapper .calendars__list .subscription__ends,
.admin-edit-user-wrapper .calendars__list .subscription__id {
  flex: 1 1 100%;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Admin/AdminUsers/AdminEditUsers.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAEF;AAAE;EACE,cDIO;ECHP,mBAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;AACJ;AACI;EASE,iBAAA;EACA,cAAA;AAPN;AAUI;EAEE,aAAA;AATN;AAYI;EACE,iBAAA;AAVN;AAaI;EAKE,cAAA;AAfN;AAqBI;;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,4CAAA;EACA,qBAAA;AAlBN;AAqBI;;EACE,eAAA;AAlBN;AAoBM;;;;EAGE,cAAA;AAjBR;AAoBM;;EACE,eAAA;AAjBR;AAkBQ;;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;AAfV;AAmBM;;EACE,iBAAA;EACA,eAAA;AAhBR;AAkBQ;;EACE,cDhEH;ACiDP;AAmBM;;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAhBR;AAmBM;;EACE,cAAA;AAhBR;AAmBM;;EACE,qBAAA;AAhBR;AAmBM;;EACE,aAAA;AAhBR;AAmBM;;EACE,aAAA;EACA,mBAAA;AAhBR;AAqBM;;EACE,eAAA;EACA,gBAAA;AAlBR;AAoBQ;;EACE,qBAAA;AAjBV;AAoBQ;;;;EAEE,aAAA;EACA,cAAA;AAhBV;AAmBQ;;;;EAGE,cAAA;EACA,gBAAA;AAhBV;AAmBQ;;;EAEE,cAAA;EACA,iBAAA;AAhBV","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors.scss';\n@import '~/Styles/Variables.scss';\n\n.admin-edit-user-wrapper {\n  user-select: auto;\n\n  .editable-value .fa {\n    color: $darkGray;\n    margin-left: 0.5rem;\n  }\n\n  .user-info {\n    display: flex;\n    flex-flow: row wrap;\n\n    &__email,\n    &__trial,\n    &__tax-percentage,\n    &__stripe-id,\n    &__paddle-id,\n    &__password,\n    &__trial,\n    &__address,\n    &__subscription-level {\n      padding: 0 0.5rem;\n      flex: 0 0 auto;\n    }\n\n    &__stripe-id,\n    &__email {\n      flex: 1 1 50%;\n    }\n\n    &__stripe-id {\n      text-align: right;\n    }\n\n    &__name,\n    &__password,\n    &__trial,\n    &__tax-percentage,\n    &__subscription-level {\n      flex: 1 1 100%;\n    }\n  }\n\n  .subscriptions,\n  .calendars {\n    &__title {\n      font-size: 2rem;\n      font-weight: bold;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n      margin-bottom: 0.5rem;\n    }\n\n    .calendar {\n      padding: 0.5rem;\n\n      &__color,\n      &__hidden,\n      &__name {\n        flex: 0 0 auto;\n      }\n\n      &__color {\n        flex: 0 0 10rem;\n        .color-box {\n          display: inline-block;\n          width: 2rem;\n          height: 2rem;\n          border-radius: 0.5rem;\n          border-width: 0.2rem;\n          border-style: solid;\n        }\n      }\n\n      &__hidden {\n        padding: 0 0.5rem;\n        font-size: 2rem;\n\n        .active {\n          color: $gold;\n        }\n      }\n\n      &__calendar-id {\n        flex: 1 1 100%;\n        text-align: right;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-left: 2rem;\n        white-space: nowrap;\n      }\n\n      &__last-error {\n        flex: 0 0 100%;\n      }\n\n      &__error-count {\n        padding-right: 0.5rem;\n      }\n\n      .calendar-top {\n        display: flex;\n      }\n\n      .calendar-bottom {\n        display: flex;\n        flex-flow: row wrap;\n      }\n    }\n\n    &__list {\n      .subscription {\n        padding: 0.5rem;\n        text-align: left;\n\n        span {\n          padding-right: 0.5rem;\n        }\n\n        .subscription-bottom,\n        .subscription-top {\n          display: flex;\n          flex-flow: row;\n        }\n\n        &__plan,\n        &__trial,\n        &__created {\n          flex: 0 0 auto;\n          text-align: left;\n        }\n\n        &__ends,\n        &__id {\n          flex: 1 1 100%;\n          text-align: right;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
